import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {SearchResultComponent} from './search-result/search-result.component';
import {SearchInputMobileComponent} from "./search-input/search-input-mobile/search-input-mobile.component";
import {SearchInputPCComponent} from "./search-input/search-input-pc/search-input-pc.component";
import {GameSearchBox} from "./boxes/game-search-box/game-search.box";
import {CyClass} from '../../../common/cy-classes';
import classNames from 'classnames';

export interface IGameSearchComponentProps {
  className?: string;
}

@observer
export class GameSearchComponent extends OrbitComponent<IGameSearchComponentProps> {
  _renderSearchInput() {
    return this.services.device.isMobile ? <SearchInputMobileComponent /> : <SearchInputPCComponent/>;
  }

  private _onUpdate = () => {
    this.services.gameSearch.searchResultComponentRef.current?.scrollTo(0, 0);
  }

  componentDidMount() {
    super.componentDidMount();
    this.services.gameSearch.searchInputRef?.current.addEventListener("input", this._onUpdate);
  }

  componentWillUnmount() {
    this.services.gameSearch.searchInputRef?.current.removeEventListener("input", this._onUpdate);
    super.componentWillUnmount();
  }
  
  render() {
    return (
      <GameSearchBox className={classNames(CyClass('cy-game-search-box'), this.props.className)} open={this.services.gameSearch.isSearchBoxOpened} ref={this.services.gameSearch.searchComponentRef}>
        {this._renderSearchInput()}
        <SearchResultComponent/>
      </GameSearchBox>
    );
  }

}
